document.addEventListener('DOMContentLoaded', function () {
  const downProduct = document.querySelector('.down-product-slider');
  if (downProduct) {
    new Splide(downProduct, {
      perPage: 1,
      perMove: 1,
      rewind: false,
      arrows: true,
      pagination: false,
    }).mount();
  }

  const featureSlider = document.querySelector('.feature-product-slider');
  if (featureSlider) {
    new Splide(featureSlider, {
      perPage: 2,
      perMove: 1,
      speed: 1000,
      rewind: false,
      arrows: true,
      pagination: false,
      breakpoints: {
        767: {
          perPage: 1
        },
      }
    }).mount();
  }
  const productMedia = document.querySelector('.product-media-slider');
  if (productMedia) {
    new Splide(productMedia, {
      perPage: 2,
      autoWidth: "true",
      perMove: 1,
      speed: 1000,
      rewind: false,
      arrows: true,
      pagination: false,
      breakpoints: {
        767: {
          perPage: 1,
        },
      }
    }).mount();
  }
  const TrustedPartnersSlider = document.querySelector('.trusted-partners-slider');
  if (TrustedPartnersSlider) {
    new Splide(TrustedPartnersSlider, {
      type: 'loop',
      autoWidth: true,
      arrows: false,
      pagination: false,
      drag: false,
      gap: '96px',
      autoScroll: {
        speed: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
    }).mount(window.splide.Extensions);
  }
  const MainProduct = document.querySelector('.main-product-section .product--stacked .mainproduct-splide-slider');
  if (MainProduct) {
    new Splide(MainProduct, {
      perPage: 1,
      perMove: 1,
      speed: 1000,
      rewind: false,
      arrows: true,
      pagination: false
    }).mount();
  }
});
